(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    const articles = document.querySelectorAll('.core-article');

    articles.forEach((article) => {
      const toc = article.querySelector('.core-article__toc');
      const tocList = article.querySelector('.core-article__toc-list');
      const content = article.querySelector('.core-article__content');

      if (!toc || !tocList || !content) return;

      const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());

      if (!headings.length) return;

      const usedIds = new Set(Array.from(document.querySelectorAll('[id]')).map((element) => element.id));

      const slugify = (text) => {
        const slug = text
          .toLowerCase()
          .trim()
          .replace(/&/g, ' and ')
          .replace(/[^a-z0-9\u00c0-\uffff]+/g, '-')
          .replace(/^-+|-+$/g, '');

        return slug || 'section';
      };

      const uniqueId = (baseId, currentId) => {
        let id = baseId;
        let index = 2;

        while (usedIds.has(id) && id !== currentId) {
          id = `${baseId}-${index}`;
          index += 1;
        }

        usedIds.add(id);
        return id;
      };

      tocList.innerHTML = '';

      headings.forEach((heading) => {
        const existingId = heading.id.trim();
        const baseId = existingId || slugify(heading.textContent);
        const id = uniqueId(baseId, existingId);
        heading.id = id;

        const item = document.createElement('li');
        const link = document.createElement('a');

        link.href = `#${id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        tocList.append(item);
      });

      toc.hidden = false;

      if (!('IntersectionObserver' in window)) return;

      const links = Array.from(tocList.querySelectorAll('a'));
      const linksById = new Map(links.map((link) => [decodeURIComponent(link.hash.slice(1)), link]));

      const setActiveLink = (id) => {
        links.forEach((link) => link.removeAttribute('aria-current'));

        const activeLink = linksById.get(id);
        if (activeLink) activeLink.setAttribute('aria-current', 'true');
      };

      const observer = new IntersectionObserver(
        (entries) => {
          const visibleEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((first, second) => first.boundingClientRect.top - second.boundingClientRect.top)[0];

          if (visibleEntry) setActiveLink(visibleEntry.target.id);
        },
        {
          rootMargin: '-20% 0px -65% 0px',
          threshold: 0
        }
      );

      headings.forEach((heading) => observer.observe(heading));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var headerEl = document.querySelector('[data-site-header]');
    if (!headerEl) return;

    var desktopEl = headerEl.querySelector('[data-header-desktop]');
    var mobileEl = headerEl.querySelector('[data-header-mobile]');
    var configUrl = headerEl.getAttribute('data-header-config-url');

    function setExternalAttrs(anchor, item) {
      var href = item.href || '';
      var isExternal = item.newTab || href.indexOf('http') === 0;

      if (isExternal) {
        anchor.target = '_blank';
        anchor.rel = 'noreferrer noopener';
      }
    }

    function createLink(item, className) {
      var anchor = document.createElement('a');
      anchor.className = className;
      anchor.href = item.href || '#';
      anchor.textContent = item.label || '';
      setExternalAttrs(anchor, item);
      return anchor;
    }

    function createProductLink(item, className) {
      var anchor = createLink(item, className);
      anchor.textContent = '';

      var name = document.createElement('span');
      name.className = className.indexOf('mobile') === -1
        ? 'site-header__product-name'
        : 'site-header__mobile-product-name';
      name.textContent = item.label || '';
      anchor.appendChild(name);

      if (item.description) {
        var description = document.createElement('span');
        description.className = className.indexOf('mobile') === -1
          ? 'site-header__product-description'
          : 'site-header__mobile-product-description';
        description.textContent = item.description;
        anchor.appendChild(description);
      }

      return anchor;
    }

    function renderDesktop(config) {
      if (!desktopEl) return;

      var list = document.createElement('ul');
      list.className = 'site-header__nav-list';
      list.setAttribute('role', 'list');

      if (config.productGroups && config.productGroups.length) {
        var productItem = document.createElement('li');
        productItem.className = 'site-header__nav-item site-header__nav-item--has-dropdown';

        var trigger = document.createElement('button');
        trigger.className = 'site-header__nav-link site-header__nav-button';
        trigger.type = 'button';
        trigger.setAttribute('aria-haspopup', 'menu');
        trigger.textContent = config.productsLabel || 'Products';
        productItem.appendChild(trigger);

        var menu = document.createElement('div');
        menu.className = 'site-header__products-menu';
        menu.setAttribute('role', 'menu');

        config.productGroups.forEach(function (group) {
          var groupEl = document.createElement('div');
          groupEl.className = 'site-header__product-group';

          var title = document.createElement('p');
          title.className = 'site-header__product-group-title';
          title.textContent = group.label || '';
          groupEl.appendChild(title);

          if (group.collectionItems && group.collectionItems.length) {
            var collectionList = document.createElement('ul');
            collectionList.className = 'site-header__collection-list';
            collectionList.setAttribute('role', 'list');

            group.collectionItems.forEach(function (item) {
              var collectionItem = document.createElement('li');
              collectionItem.appendChild(createLink(item, 'site-header__collection-link'));
              collectionList.appendChild(collectionItem);
            });

            groupEl.appendChild(collectionList);
          }

          var groupList = document.createElement('ul');
          groupList.className = 'site-header__product-list';
          groupList.setAttribute('role', 'list');

          (group.items || []).forEach(function (item) {
            var listItem = document.createElement('li');
            listItem.className = 'site-header__product-item';
            listItem.appendChild(createProductLink(item, 'site-header__product-link'));
            groupList.appendChild(listItem);
          });

          groupEl.appendChild(groupList);
          menu.appendChild(groupEl);
        });

        productItem.appendChild(menu);
        list.appendChild(productItem);
      }

      (config.links || []).forEach(function (item) {
        var listItem = document.createElement('li');
        listItem.className = 'site-header__nav-item';

        if (item.items && item.items.length) {
          listItem.className += ' site-header__nav-item--has-dropdown';

          var trigger = document.createElement('button');
          trigger.className = 'site-header__nav-link site-header__nav-button';
          trigger.type = 'button';
          trigger.setAttribute('aria-haspopup', 'menu');
          trigger.textContent = item.label || '';
          listItem.appendChild(trigger);

          var dropdown = document.createElement('ul');
          dropdown.className = 'site-header__links-menu';
          dropdown.setAttribute('role', 'menu');

          item.items.forEach(function (subItem) {
            var dropdownItem = document.createElement('li');
            dropdownItem.appendChild(createLink(subItem, 'site-header__nav-link'));
            dropdown.appendChild(dropdownItem);
          });

          listItem.appendChild(dropdown);
        } else {
          listItem.appendChild(createLink(item, 'site-header__nav-link'));
        }

        list.appendChild(listItem);
      });

      desktopEl.replaceChildren(list);
    }

    function renderMobile(config) {
      if (!mobileEl) return;

      if (config.productGroups && config.productGroups.length) {
        var details = document.createElement('details');
        details.className = 'site-header__mobile-details';
        details.open = true;

        var summary = document.createElement('summary');
        summary.className = 'site-header__mobile-summary';

        var summaryLabel = document.createElement('span');
        summaryLabel.className = 'site-header__mobile-summary-label';
        summaryLabel.textContent = config.productsLabel || 'Products';
        summary.appendChild(summaryLabel);
        details.appendChild(summary);

        var nested = document.createElement('div');
        nested.className = 'site-header__mobile-nested';

        config.productGroups.forEach(function (group) {
          var groupEl = document.createElement('div');
          groupEl.className = 'site-header__mobile-group';

          var title = document.createElement('p');
          title.className = 'site-header__mobile-group-title';
          title.textContent = group.label || '';
          groupEl.appendChild(title);

          if (group.collectionItems && group.collectionItems.length) {
            var collectionList = document.createElement('div');
            collectionList.className = 'site-header__mobile-collection-list';

            group.collectionItems.forEach(function (item) {
              collectionList.appendChild(createLink(item, 'site-header__mobile-link'));
            });

            groupEl.appendChild(collectionList);
          }

          (group.items || []).forEach(function (item) {
            groupEl.appendChild(createProductLink(item, 'site-header__mobile-link site-header__mobile-product-link'));
          });

          nested.appendChild(groupEl);
        });

        details.appendChild(nested);
        mobileEl.appendChild(details);
      }

      if (config.links && config.links.length) {
        var linkGroup = document.createElement('div');
        linkGroup.className = 'site-header__mobile-group';

        var linkTitle = document.createElement('p');
        linkTitle.className = 'site-header__mobile-group-title';
        linkTitle.textContent = config.mobileLinksLabel || 'Explore';
        linkGroup.appendChild(linkTitle);

        config.links.forEach(function (item) {
          if (item.items && item.items.length) {
            var details = document.createElement('details');
            details.className = 'site-header__mobile-details';

            var summary = document.createElement('summary');
            summary.className = 'site-header__mobile-summary';

            var summaryLabel = document.createElement('span');
            summaryLabel.className = 'site-header__mobile-summary-label';
            summaryLabel.textContent = item.label || '';
            summary.appendChild(summaryLabel);
            details.appendChild(summary);

            var nested = document.createElement('div');
            nested.className = 'site-header__mobile-nested';

            item.items.forEach(function (subItem) {
              nested.appendChild(createLink(subItem, 'site-header__mobile-link'));
            });

            details.appendChild(nested);
            linkGroup.appendChild(details);
          } else {
            linkGroup.appendChild(createLink(item, 'site-header__mobile-link'));
          }
        });

        mobileEl.appendChild(linkGroup);
      }

    }

    function renderHeader(config) {
      renderDesktop(config);
      renderMobile(config);
    }

    var ticking = false;
    function updateScrollState() {
      headerEl.setAttribute('data-scrolled', window.scrollY > 40 ? 'true' : 'false');
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollState);
        ticking = true;
      }
    }

    updateScrollState();
    window.addEventListener('scroll', onScroll, { passive: true });

    if (configUrl) {
      fetch(configUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('Header config request failed');
          return response.json();
        })
        .then(renderHeader)
        .catch(function (error) {
          console.warn(error);
        });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      if (typeof Swiper === 'undefined') return;
      var el = document.querySelector('[data-hero-swiper]');
      if (!el || el.dataset.swiperReady === 'true') return;
      el.dataset.swiperReady = 'true';
      new Swiper(el, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: { delay: 5000, disableOnInteraction: false },
        pagination: {
          el: el.querySelector('.hero-swiper__pagination'),
          clickable: true,
          dynamicBullets: true
        }
      });
    }

    if (typeof Swiper !== 'undefined') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (typeof Swiper !== 'undefined') {
          clearInterval(poll);
          init();
        } else if (tries > 50) {
          clearInterval(poll);
        }
      }, 100);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-apply-rma"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hzboost-claim]');
    if (!root) return;

    var form = root.querySelector('form');
    if (!form) return;

    form.noValidate = true;

    var successModal = root.querySelector('[data-rma-success-modal]');
    var successCloseButtons = root.querySelectorAll('[data-rma-success-close]');
    var successRestoreFocus = null;
    var defectOptions = root.querySelectorAll('[data-defect-option]');
    var defectGroup = root.querySelector('[data-defect-group]');
    var otherDefect = root.querySelector('[data-other-defect]');
    var otherPanel = root.querySelector('[data-other-panel]');
    var otherDetail = root.querySelector('[data-other-detail]');
    var defectError = root.querySelector('[data-defect-error]');
    var evidenceInput = root.querySelector('[data-evidence-upload]');
    var evidenceFileList = root.querySelector('[data-evidence-file-list]');
    var evidenceFiles = [];
    var evidenceError = root.querySelector('[data-evidence-error]');
    var proofInput = root.querySelector('[data-proof-upload]');
    var videoInput = root.querySelector('[data-video-upload]');
    var defectSummary = root.querySelector('[data-defect-summary]');
    var proofFileName = root.querySelector('[data-proof-file-name]');
    var evidenceFileNames = root.querySelector('[data-evidence-file-names]');
    var videoFileName = root.querySelector('[data-video-file-name]');
    var fieldErrorIndex = 0;
    var validationMessages = {
      required: root.getAttribute('data-error-required') || 'This field is required.',
      email: root.getAttribute('data-error-email') || 'Enter a valid email address.',
      file: root.getAttribute('data-error-file') || 'Choose a file before submitting.',
      checkbox: root.getAttribute('data-error-checkbox') || 'Please confirm this required checkbox.'
    };

    function openSuccessModal() {
      if (!successModal) return;
      successRestoreFocus = document.activeElement;
      successModal.hidden = false;
      document.body.classList.add('page-apply-rma-modal-open');

      var dialog = successModal.querySelector('[data-rma-success-dialog]');
      if (dialog) dialog.focus();
    }

    function closeSuccessModal() {
      if (!successModal) return;
      successModal.hidden = true;
      document.body.classList.remove('page-apply-rma-modal-open');

      if (successRestoreFocus && typeof successRestoreFocus.focus === 'function') {
        successRestoreFocus.focus();
      }
    }

    function isLocalThemePreview() {
      return window.location.hostname === '127.0.0.1'
        || window.location.hostname === 'localhost'
        || window.location.hostname === '::1';
    }

    if (isLocalThemePreview()) {
      form.setAttribute('action', '#' + form.id);
    }

    if (successModal) {
      Array.prototype.forEach.call(successCloseButtons, function (button) {
        button.addEventListener('click', closeSuccessModal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !successModal.hidden) {
          closeSuccessModal();
        }
      });

      if (successModal.hasAttribute('data-rma-success-autopen')) {
        window.setTimeout(openSuccessModal, 80);
      }
    }

    function fieldContainer(input) {
      return input.closest('.page-apply-rma__field') || input.closest('.page-apply-rma__confirm') || input.parentNode;
    }

    function errorIdFor(input) {
      var errorId = input.getAttribute('data-error-id');
      if (!errorId) {
        fieldErrorIndex += 1;
        errorId = (input.id || 'RmaField') + '-Error-' + fieldErrorIndex;
        input.setAttribute('data-error-id', errorId);
      }
      return errorId;
    }

    function appendDescribedBy(input, errorId) {
      var current = input.getAttribute('aria-describedby') || '';
      var ids = current.split(' ').filter(Boolean);

      if (ids.indexOf(errorId) === -1) {
        ids.push(errorId);
        input.setAttribute('aria-describedby', ids.join(' '));
      }
    }

    function removeDescribedBy(input, errorId) {
      var current = input.getAttribute('aria-describedby') || '';
      var ids = current.split(' ').filter(function (id) {
        return id && id !== errorId;
      });

      if (ids.length) {
        input.setAttribute('aria-describedby', ids.join(' '));
      } else {
        input.removeAttribute('aria-describedby');
      }
    }

    function setFieldError(input, message) {
      if (!input) return;

      var container = fieldContainer(input);
      if (!container) return;

      var errorId = errorIdFor(input);
      var error = container.querySelector('[data-field-error-message]');

      if (!error) {
        error = document.createElement('p');
        error.className = 'page-apply-rma__field-error-message';
        error.setAttribute('data-field-error-message', '');
        container.appendChild(error);
      }

      error.id = errorId;
      error.textContent = message;
      input.setAttribute('aria-invalid', 'true');
      appendDescribedBy(input, errorId);

      if (container.classList.contains('page-apply-rma__confirm')) {
        container.setAttribute('aria-invalid', 'true');
      }
    }

    function clearFieldError(input) {
      if (!input) return;

      var container = fieldContainer(input);
      var errorId = input.getAttribute('data-error-id');
      var error = container ? container.querySelector('[data-field-error-message]') : null;

      if (error) error.remove();
      input.removeAttribute('aria-invalid');

      if (errorId) {
        removeDescribedBy(input, errorId);
      }

      if (container && container.classList.contains('page-apply-rma__confirm')) {
        container.removeAttribute('aria-invalid');
      }
    }

    function isVisibleField(input) {
      return input.type !== 'hidden' && !input.closest('[hidden]');
    }

    function validateRequiredField(input) {
      if (!input || !input.required || !isVisibleField(input)) {
        clearFieldError(input);
        return true;
      }

      if (input.hasAttribute('data-evidence-upload')) {
        return true;
      }

      if (input.type === 'checkbox') {
        if (!input.checked) {
          setFieldError(input, validationMessages.checkbox);
          return false;
        }

        clearFieldError(input);
        return true;
      }

      if (input.type === 'file') {
        if (!input.files || input.files.length === 0) {
          setFieldError(input, validationMessages.file);
          return false;
        }

        clearFieldError(input);
        return true;
      }

      if (!input.value || input.value.trim() === '') {
        setFieldError(input, validationMessages.required);
        return false;
      }

      if (input.type === 'email' && input.validity.typeMismatch) {
        setFieldError(input, validationMessages.email);
        return false;
      }

      clearFieldError(input);
      return true;
    }

    function validateRequiredFields() {
      var fields = form.querySelectorAll('input[required], select[required], textarea[required]');
      var firstInvalid = null;

      Array.prototype.forEach.call(fields, function (input) {
        var isValid = validateRequiredField(input);

        if (!isValid && !firstInvalid) {
          firstInvalid = input;
        }
      });

      return {
        isValid: firstInvalid === null,
        firstInvalid: firstInvalid
      };
    }

    function fileIdentity(file) {
      return [file.name, file.size, file.lastModified].join('|');
    }

    function formatFileSize(size) {
      if (!size) return '0 KB';
      if (size < 1024 * 1024) return Math.ceil(size / 1024) + ' KB';
      return (size / 1024 / 1024).toFixed(1) + ' MB';
    }

    function syncEvidenceInput() {
      if (!evidenceInput || !window.DataTransfer) return;

      try {
        var dataTransfer = new DataTransfer();
        evidenceFiles.forEach(function (file) {
          dataTransfer.items.add(file);
        });
        evidenceInput.files = dataTransfer.files;
      } catch (error) {
        return;
      }
    }

    function renderEvidenceFiles() {
      if (!evidenceFileList) return;

      var removeLabel = evidenceFileList.getAttribute('data-remove-label') || 'Remove';
      evidenceFileList.innerHTML = '';
      evidenceFileList.hidden = evidenceFiles.length === 0;

      evidenceFiles.forEach(function (file, index) {
        var item = document.createElement('li');
        var fileText = document.createElement('span');
        var fileName = document.createElement('span');
        var fileSize = document.createElement('span');
        var removeButton = document.createElement('button');

        item.className = 'page-apply-rma__file-item';
        fileName.className = 'page-apply-rma__file-name';
        fileSize.className = 'page-apply-rma__file-size';
        removeButton.className = 'page-apply-rma__file-remove';

        fileName.textContent = file.name;
        fileSize.textContent = formatFileSize(file.size);
        removeButton.type = 'button';
        removeButton.textContent = removeLabel;
        removeButton.setAttribute('aria-label', removeLabel + ' ' + file.name);
        removeButton.addEventListener('click', function () {
          evidenceFiles.splice(index, 1);
          syncEvidenceInput();
          renderEvidenceFiles();
          validateEvidence();
          setHiddenSummaries();
          if (evidenceInput) evidenceInput.focus();
        });

        fileText.appendChild(fileName);
        fileText.appendChild(fileSize);
        item.appendChild(fileText);
        item.appendChild(removeButton);
        evidenceFileList.appendChild(item);
      });
    }

    function addEvidenceFiles(fileList) {
      Array.prototype.forEach.call(fileList || [], function (file) {
        var identity = fileIdentity(file);
        var isDuplicate = evidenceFiles.some(function (selectedFile) {
          return fileIdentity(selectedFile) === identity;
        });

        if (!isDuplicate) {
          evidenceFiles.push(file);
        }
      });

      syncEvidenceInput();
      renderEvidenceFiles();
    }

    function selectedDefects() {
      return Array.prototype.filter.call(defectOptions, function (option) {
        return option.checked;
      });
    }

    function fileNames(input) {
      if (!input || !input.files) return '';
      return Array.prototype.map.call(input.files, function (file) {
        return file.name;
      }).join(', ');
    }

    function setHiddenSummaries() {
      if (defectSummary) {
        defectSummary.value = selectedDefects().map(function (option) {
          return option.value;
        }).join(' | ');
      }
      if (proofFileName) proofFileName.value = fileNames(proofInput);
      if (evidenceFileNames) {
        evidenceFileNames.value = evidenceFiles.map(function (file) {
          return file.name;
        }).join(', ');
      }
      if (videoFileName) videoFileName.value = fileNames(videoInput);
    }

    function validateDefects() {
      var isValid = selectedDefects().length > 0;
      if (defectError) defectError.hidden = isValid;
      if (defectGroup) {
        if (isValid) {
          defectGroup.removeAttribute('aria-invalid');
        } else {
          defectGroup.setAttribute('aria-invalid', 'true');
        }
      }
      return isValid;
    }

    function validateEvidence() {
      if (!evidenceInput) return true;
      var count = evidenceFiles.length;
      var isValid = count >= 2 && count <= 4;
      if (evidenceError) evidenceError.hidden = isValid;
      if (!isValid) {
        evidenceInput.setAttribute('aria-invalid', 'true');
        evidenceInput.setCustomValidity('Upload 2 to 4 clear photos or short videos.');
      } else {
        evidenceInput.removeAttribute('aria-invalid');
        evidenceInput.setCustomValidity('');
      }
      return isValid;
    }

    function updateOtherState() {
      var enabled = otherDefect && otherDefect.checked;
      if (otherPanel) otherPanel.hidden = !enabled;
      if (otherDetail) otherDetail.required = !!enabled;
    }

    Array.prototype.forEach.call(defectOptions, function (option) {
      option.addEventListener('change', function () {
        updateOtherState();
        validateDefects();
        if (otherDetail && otherDetail.required) {
          validateRequiredField(otherDetail);
        } else {
          clearFieldError(otherDetail);
        }
        setHiddenSummaries();
      });
    });

    [proofInput, videoInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('change', function () {
        validateRequiredField(input);
        validateEvidence();
        setHiddenSummaries();
      });
    });

    Array.prototype.forEach.call(form.querySelectorAll('input[required], select[required], textarea[required]'), function (input) {
      if (input.hasAttribute('data-evidence-upload')) return;

      var eventName = input.type === 'checkbox' || input.type === 'file' || input.type === 'date' ? 'change' : 'input';
      input.addEventListener(eventName, function () {
        validateRequiredField(input);
      });

      if (input.type === 'email') {
        input.addEventListener('blur', function () {
          validateRequiredField(input);
        });
      }
    });

    if (evidenceInput) {
      evidenceInput.addEventListener('change', function () {
        addEvidenceFiles(evidenceInput.files);
        validateEvidence();
        setHiddenSummaries();
      });
    }

    renderEvidenceFiles();

    function handleSubmit(event) {
      var isLocalPreview = isLocalThemePreview();

      if (isLocalPreview) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      setHiddenSummaries();
      updateOtherState();

      var requiredValidation = validateRequiredFields();
      var defectsValid = validateDefects();
      var evidenceValid = validateEvidence();

      if (!requiredValidation.isValid || !defectsValid || !evidenceValid) {
        event.preventDefault();
        if (requiredValidation.firstInvalid) {
          requiredValidation.firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          requiredValidation.firstInvalid.focus();
        } else if (!defectsValid && defectError) {
          defectError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (!evidenceValid && evidenceInput) {
          evidenceInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          evidenceInput.focus();
        }
      } else if (isLocalPreview) {
        openSuccessModal();
        if (window.gtekTrack) {
          window.gtekTrack('lead_form_submit_preview', {
            event_category: 'lead',
            event_label: 'hzboost warranty claim local preview',
            inquiry_type: 'HzBoost warranty claim'
          });
        }
      }
    }

    form.addEventListener('submit', handleSubmit, true);

    updateOtherState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.page-contact');
    if (!root) return;

    var topicField = root.querySelector('[data-lead-topic-field]');
    var topicButtons = root.querySelectorAll('[data-lead-topic-option]');

    if (!topicField || !topicButtons.length) return;

    function setActive(value) {
      topicField.value = value;
      topicButtons.forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute('data-value') === value);
      });
    }

    topicButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setActive(button.getAttribute('data-value') || '');
      });
    });

    setActive(topicField.value || topicButtons[0].getAttribute('data-value') || 'Book a demo');

    var successModal = root.querySelector('[data-contact-success-modal]');
    if (successModal) {
      var closeButton = successModal.querySelector('[data-contact-success-close]');

      function closeSuccessModal() {
        successModal.classList.add('is-hidden');
      }

      if (closeButton) {
        closeButton.addEventListener('click', closeSuccessModal);
        closeButton.focus();
      }

      successModal.addEventListener('click', function (event) {
        if (event.target === successModal) {
          closeSuccessModal();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeSuccessModal();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-for-education"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initEducationStorySwipers() {
      if (typeof Swiper === 'undefined') return;

      var swipers = document.querySelectorAll('[data-education-story-swiper]');
      swipers.forEach(function (el) {
        if (el.dataset.swiperReady === 'true') return;

        el.dataset.swiperReady = 'true';
        new Swiper(el, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          autoplay: { delay: 4500, disableOnInteraction: false },
          pagination: {
            el: el.querySelector('.for-education-story-swiper__pagination'),
            clickable: true,
            dynamicBullets: true
          }
        });
      });
    }

    if (typeof Swiper !== 'undefined') {
      initEducationStorySwipers();
    } else {
      document.addEventListener('DOMContentLoaded', initEducationStorySwipers);
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (typeof Swiper !== 'undefined') {
          clearInterval(poll);
          initEducationStorySwipers();
        } else if (tries > 50) {
          clearInterval(poll);
        }
      }, 100);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-warranty"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-warranty-root]')
  if (!root) return

  var serialInput = root.querySelector('[data-warranty-serial]')
  var orderInput = root.querySelector('[data-warranty-order]')
  var verifyForm = root.querySelector('[data-warranty-verify]')
  var okBox = root.querySelector('[data-warranty-msg-ok]')
  var failBox = root.querySelector('[data-warranty-msg-fail]')
  var planButtons = root.querySelectorAll('[data-warranty-plan]')
  var summaryLabel = root.querySelector('[data-warranty-summary-label]')
  var summaryPrice = root.querySelector('[data-warranty-summary-price]')
  var checkoutBtn = root.querySelector('[data-warranty-checkout]')
  var productUrl = root.getAttribute('data-product-url') || '#'
  var eligibilityUrl = root.getAttribute('data-eligibility-url')
  var lblSelected = root.getAttribute('data-i18n-selected') || 'Selected'
  var lblSelect = root.getAttribute('data-i18n-select') || 'Select plan'
  var addTemplate = root.getAttribute('data-i18n-add-template') || 'Add __PLAN__ to cart'
  var activePlanButton = null

  function setActivePlan(key) {
    planButtons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-plan-key') === key
      btn.setAttribute('data-active', String(isActive))
      var pill = btn.querySelector('[data-plan-pill]')
      if (pill) pill.textContent = isActive ? lblSelected : lblSelect
    })
    var activeBtn = Array.prototype.find.call(planButtons, function (b) {
      return b.getAttribute('data-active') === 'true'
    })
    activePlanButton = activeBtn || null
    if (activeBtn && summaryLabel && summaryPrice) {
      summaryLabel.textContent = activeBtn.getAttribute('data-plan-name') || ''
      summaryPrice.textContent = activeBtn.getAttribute('data-plan-price') || ''
    }
    if (checkoutBtn) {
      var label = activeBtn ? activeBtn.getAttribute('data-plan-name') : ''
      checkoutBtn.textContent = addTemplate.split('__PLAN__').join(label || '').trim()
      checkoutBtn.setAttribute('href', productUrl)
    }
  }

  function showMessage(box) {
    if (okBox) {
      okBox.classList.add('hidden')
      okBox.classList.remove('flex')
    }
    if (failBox) {
      failBox.classList.add('hidden')
      failBox.classList.remove('flex')
    }
    if (box) {
      box.classList.remove('hidden')
      box.classList.add('flex')
    }
  }

  function isEligibleResponse(data) {
    if (!data) return false
    if (data.data) return isEligibleResponse(data.data)
    if (data.result) return isEligibleResponse(data.result)
    if (data.eligible === true) return true
    if (data.isEligible === true) return true
    if (data.success === true) return true
    if (typeof data.status === 'string') {
      var status = data.status.toLowerCase()
      if (status === 'eligible' || status === 'success' || status === 'ok') return true
    }
    return false
  }

  function addSelectedPlanToCart(e) {
    if (!checkoutBtn || !activePlanButton) return
    var variantId = activePlanButton.getAttribute('data-variant-id')
    if (!variantId) return
    var numericVariantId = Number(variantId)
    if (!numericVariantId) return

    e.preventDefault()
    checkoutBtn.setAttribute('aria-busy', 'true')

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: numericVariantId,
            quantity: 1
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add warranty plan to cart.')
        window.location.href = '/checkout'
      })
      .catch(function () {
        window.location.href = productUrl
      })
      .finally(function () {
        checkoutBtn.removeAttribute('aria-busy')
      })
  }

  var initial = Array.prototype.find.call(planButtons, function (b) {
    return b.getAttribute('data-plan-key') === 'care-plus'
  })
  setActivePlan(initial ? 'care-plus' : (planButtons[0] && planButtons[0].getAttribute('data-plan-key')) || 'care')

  planButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setActivePlan(btn.getAttribute('data-plan-key') || 'care')
    })
  })

  if (verifyForm) {
    verifyForm.addEventListener('submit', function (e) {
      e.preventDefault()
      showMessage(null)
      if (!serialInput || !orderInput) return
      var serialNumber = serialInput.value.trim()
      var orderId = orderInput.value.trim()
      if (!serialNumber || !orderId || !eligibilityUrl) {
        showMessage(failBox)
        return
      }
      var submitBtn = verifyForm.querySelector('button[type="submit"]')
      if (submitBtn) submitBtn.disabled = true

      var obj = {
        serialNumber: serialNumber,
        orderId: orderId
      }

      fetch(eligibilityUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(obj)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Eligibility check failed.')
          return response.json()
        })
        .then(function (data) {
          showMessage(isEligibleResponse(data) ? okBox : failBox)
        })
        .catch(function () {
          showMessage(failBox)
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false
        })
    })
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', addSelectedPlanToCart)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-warranty"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-product-warranty-root]')
  if (!root) return

  var serialInput = root.querySelector('[data-warranty-serial]')
  var orderInput = root.querySelector('[data-warranty-order]')
  var verifyForm = root.querySelector('[data-warranty-verify]')
  var okBox = root.querySelector('[data-warranty-msg-ok]')
  var failBox = root.querySelector('[data-warranty-msg-fail]')
  var msgBox = root.querySelector('[data-result-msg]')
  var resultBox = root.querySelector('[data-warranty-result]')
  var resultStatus = root.querySelector('[data-warranty-result-status]')
  var resultIwb = root.querySelector('[data-warranty-result-iwb]')
  var resultOps = root.querySelector('[data-warranty-result-ops]')
  var planButtons = root.querySelectorAll('[data-warranty-plan]')
  var variantInput = root.querySelector('[data-warranty-variant-id]')
  var productForm = variantInput ? variantInput.closest('form') : null
  var summaryLabel = root.querySelector('[data-warranty-summary-label]')
  var summaryPrice = root.querySelector('[data-warranty-summary-price]')
  var addButton = root.querySelector('[data-warranty-add]')
  var addText = root.querySelector('[data-warranty-add-text]')
  var eligibilityUrl = root.getAttribute('data-eligibility-url')
  var registerationAppPath = root.getAttribute('data-eligiblilty-app-path')
  var lblSelected = root.getAttribute('data-i18n-selected') || 'Selected'
  var lblSelect = root.getAttribute('data-i18n-select') || 'Select plan'
  var addTemplate = root.getAttribute('data-i18n-add-template') || 'Add __PLAN__ to cart'
  var lblSoldOut = root.getAttribute('data-i18n-sold-out') || 'Sold out'
  var lblUnavailable = root.getAttribute('data-i18n-unavailable') || 'Unavailable'
  var variantsScript = root.querySelector('[data-warranty-product-variants]');
  var variants = [];
  if (variantsScript) {
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      variants = [];
    }
  }
  const skuToWarrantyOptions = {
    "65B1TW+AR8128FBA": {
      iwbModel: "65B1TW",
      opsPackage: "AR8128"
    },
    "65B1TW+AR8128": {
      iwbModel: "65B1TW",
      opsPackage: "AR8128"
    },
    "65B1TW+ARP16256": {
      iwbModel: "65B1TW",
      opsPackage: "ARP16256"
    },
    "65B1TW+AR8128&I7": {
      iwbModel: "65B1TW",
      opsPackage: "AR8128 + WIN_I7"
    },
    "65B1TW+ARP16256&I7": {
      iwbModel: "65B1TW",
      opsPackage: "ARP16256 + WIN_I7"
    },
    "75B1TW+AR8128": {
      iwbModel: "75B1TW",
      opsPackage: "AR8128"
    },
    "75B1TW+ARP16256": {
      iwbModel: "75B1TW",
      opsPackage: "ARP16256"
    },
    "75B1TW+AR8128&I7": {
      iwbModel: "75B1TW",
      opsPackage: "AR8128 + WIN_I7"
    },
    "75B1TW+ARP16256&I7": {
      iwbModel: "75B1TW",
      opsPackage: "ARP16256 + WIN_I7"
    },
    "86B1TW+AR8128": {
      iwbModel: "86B1TW",
      opsPackage: "AR8128"
    },
    "86B1TW+ARP16256": {
      iwbModel: "86B1TW",
      opsPackage: "ARP16256"
    },
    "86B1TW+AR8128&I7": {
      iwbModel: "86B1TW",
      opsPackage: "AR8128 + WIN_I7"
    },
    "86B1TW+ARP16256&I7": {
      iwbModel: "86B1TW",
      opsPackage: "ARP16256 + WIN_I7"
    },
    "96B1TW+ARP16256": {
      iwbModel: "98B1TW",
      opsPackage: "ARP16256"
    },
    "98B1TW+AR8128": {
      iwbModel: "98B1TW",
      opsPackage: "AR8128"
    },
    "96B1TW+ARP162256&I7": {
      iwbModel: "98B1TW",
      opsPackage: "ARP16256 + WIN_I7"
    },
    "96B1TW+ARP16256&I7": {
      iwbModel: "98B1TW",
      opsPackage: "ARP16256 + WIN_I7"
    },
    "98B1TW+AR8128&I7": {
      iwbModel: "98B1TW",
      opsPackage: "AR8128 + WIN_I7"
    }
  };

  function getActiveButton() {
    return Array.prototype.find.call(planButtons, function (button) {
      return button.getAttribute('data-active') === 'true'
    })
  }
  function setActivePlan(button) {
    if (!button) return;

    var variantId = button.getAttribute('data-variant-id') || '';
    var isAvailable = button.getAttribute('data-variant-available') === 'true';

    if (!variantId || !isAvailable) {
      if (variantInput) variantInput.value = '';
      if (addButton) addButton.disabled = true;
      if (addText) addText.textContent = lblUnavailable;
      return;
    }

    planButtons.forEach(function (planButton) {
      var isActive = planButton === button;
      var planAvailable = planButton.getAttribute('data-variant-available') === 'true';
      var pill = planButton.querySelector('[data-plan-pill]');

      planButton.setAttribute('data-active', String(isActive));

      if (pill) {
        if (isActive) {
          pill.textContent = planAvailable ? lblSelected : lblSoldOut;
        } else {
          pill.textContent = planAvailable ? lblSelect : lblSoldOut;
        }
      }
    });

    if (variantInput) variantInput.value = variantId;

    if (summaryLabel) {
      summaryLabel.textContent = button.getAttribute('data-plan-name') || '';
    }

    if (summaryPrice) {
      summaryPrice.textContent = button.getAttribute('data-plan-price') || '';
    }

    if (addButton) {
      addButton.disabled = !isAvailable;
    }

    if (addText) {
      var planName = button.getAttribute('data-plan-name') || '';
      addText.textContent = addTemplate.split('__PLAN__').join(planName).trim();
    }
  }
  function showBox(box) {
    hideAllMessages()

    if (box) {
      box.classList.remove('hidden')
      box.classList.add('flex')
    }
  }
  function showMsg(message) {
    hideAllMessages()

    if (msgBox) {
      var msgText = msgBox.querySelector('p')
      if (msgText) {
        msgText.textContent = message || ''
      }
      msgBox.classList.remove('hidden')
      msgBox.classList.add('flex')
    }
  }
  function hideAllMessages() {
    if (okBox) {
      okBox.classList.add('hidden')
      okBox.classList.remove('flex')
    }

    if (failBox) {
      failBox.classList.add('hidden')
      failBox.classList.remove('flex')
    }

    if (msgBox) {
      msgBox.classList.add('hidden')
      msgBox.classList.remove('flex')
    }
  }
  function hideEligibilityResult() {
    if (resultBox) {
      resultBox.classList.add('hidden')
      resultBox.classList.remove('block')
    }
  }
  function showEligibilityResult(match, isEligible) {
    if (!resultBox) return

    if (resultIwb) resultIwb.textContent = match && match.iwbModel ? match.iwbModel : '--'
    if (resultOps) resultOps.textContent = match && match.opsPackage ? match.opsPackage : '--'

    if (resultStatus) {
      resultStatus.textContent = isEligible ? 'Eligible' : 'Not eligible'
      resultStatus.classList.toggle('bg-muted', !isEligible)
      resultStatus.classList.toggle('text-muted-foreground', !isEligible)
      resultStatus.classList.toggle('bg-foreground', isEligible)
      resultStatus.classList.toggle('text-background', isEligible)
    }

    resultBox.classList.remove('hidden')
    resultBox.classList.add('block')
  }
  function isEligibleResponse(data) {
    if (!data) return false
    if (data.data) return isEligibleResponse(data.data)
    if (data.result) return isEligibleResponse(data.result)
    if (data.eligible === true) return true
    if (data.isEligible === true) return true
    if (data.success === true) return true
    if (typeof data.status === 'string') {
      var status = data.status.toLowerCase()
      if (status === 'eligible' || status === 'success' || status === 'ok') return true
    }
    return false
  }
  planButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setActivePlan(button)
    })
  })

  if (productForm) {
    productForm.addEventListener('submit', function (event) {
      if (!variantInput || !variantInput.value) {
        event.preventDefault()
        showMsg('Please verify your device and select an available warranty plan first.')
      }
    })
  }
  
  setActivePlan(getActiveButton() || planButtons[0])

  
  function getPlanButton(planName) {
    return Array.prototype.find.call(planButtons, function (button) {
      return (button.getAttribute('data-plan-name') || '').toLowerCase() === planName.toLowerCase()
    })
  }

  function updatePlanButton(button, variant) {
    if (!button) return;

    var priceDisplay = button.querySelector('[data-plan-price-display]');
    var pill = button.querySelector('[data-plan-pill]');

    if (!variant) {
      button.setAttribute('data-variant-id', '');
      button.setAttribute('data-plan-price', '');
      button.setAttribute('data-variant-available', 'false');
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');

      if (priceDisplay) priceDisplay.textContent = '--';
      if (pill) pill.textContent = lblUnavailable;

      return;
    }

    button.setAttribute('data-variant-id', variant.id);
    button.setAttribute('data-plan-price', variant.price);
    button.setAttribute('data-variant-available', String(variant.available));
    button.disabled = !variant.available;
    button.setAttribute('aria-disabled', String(!variant.available));

    if (priceDisplay) priceDisplay.textContent = variant.price;

    if (pill) {
      var isActive = button.getAttribute('data-active') === 'true';

      if (isActive) {
        pill.textContent = variant.available ? lblSelected : lblSoldOut;
      } else {
        pill.textContent = variant.available ? lblSelect : lblSoldOut;
      }
    }
  }

  function check_registration(doc) {
    var SN_register = false;
    var SN_register_in90days = false;
    var SN_notExtended = false;

    const [warrantyStart, warrantyEnd] = doc.querySelectorAll('._mpr-warranty-entry');
    if (warrantyStart && warrantyEnd) {
        SN_register = true;
        const parseDate = el => el.querySelector('p')?.textContent.split(": ")[1] ?? null;
        const startDate = parseDate(warrantyStart);
        const endDate = parseDate(warrantyEnd);

        if (startDate && isWithin90Days(startDate)) SN_register_in90days = true;

        const currentWarrantyLength = checkWarrantyLength(startDate, endDate);
        if (currentWarrantyLength >= 0 && currentWarrantyLength <= 4) SN_notExtended = true;
    }
    let errorMsg = createErrorMsg(SN_register, SN_register_in90days, SN_notExtended);
    return errorMsg ? errorMsg : null;
  }
  function isWithin90Days(dateStr) {
      const target = new Date(dateStr);
      const today = new Date();
      const diffDays = (today - target) / (1000 * 60 * 60 * 24);
      return diffDays >= 0 && diffDays <= 90;
  }
  function checkWarrantyLength(dataStr, dataEnd) {
      const diff = (new Date(dataEnd) - new Date(dataStr)) / (1000 * 60 * 60 * 24 * 365.25);
      return diff;
  }
  function createErrorMsg(SN_register, SN_register_in90days, SN_notExtended) {
      if (!SN_register) return "Please register the product before adding to cart.";
      if (!SN_register_in90days) return "The product is not allowed to extend warranty after 90 days from registration.";
      if (!SN_notExtended) return "The product has already been extended once.";
      return null;
  }
  function normalizeOptionValue(value) {
    return String(value || '').trim().toUpperCase()
  }
  function normalizeComparableOption(value) {
    return normalizeOptionValue(value)
      .replace(/PLUS/g, '+')
      .replace(/WIN[\s_-]*I7/g, 'I7')
      .replace(/[^A-Z0-9+]/g, '')
  }
  function normalizeProductOption(value) {
    return normalizeComparableOption(value).replace(/\+/g, '')
  }
  function normalizePlanOption(value) {
    return normalizeComparableOption(value)
      .replace(/GTEKCARE\+/g, 'GTEKCAREPLUS')
      .replace(/GTEKCARE$/g, 'GTEKCARE')
  }
  function optionMatches(value, target) {
    return normalizeProductOption(value) === normalizeProductOption(target)
  }
  function planMatches(value, target) {
    return normalizePlanOption(value) === normalizePlanOption(target)
  }
  function findWarrantyVariant(iwbModel, opsPackage, planName) {
    var orderedMatch = variants.find(function (variant) {
      return optionMatches(variant.options[0], iwbModel) &&
        optionMatches(variant.options[1], opsPackage) &&
        planMatches(variant.options[2], planName);
    });

    if (orderedMatch) return orderedMatch

    return variants.find(function (variant) {
      var options = variant.options || []
      var hasIwbModel = options.some(function (option) {
        return optionMatches(option, iwbModel)
      })
      var hasOpsPackage = options.some(function (option) {
        return optionMatches(option, opsPackage)
      })
      var hasPlanName = options.some(function (option) {
        return planMatches(option, planName)
      })

      return hasIwbModel && hasOpsPackage && hasPlanName
    });
  }
  function getWarrantyOptionsForSku(orderSku) {
    orderSku = String(orderSku || '').trim()
    return skuToWarrantyOptions[orderSku]
  }
  function applyWarrantyOptions(orderSku) {
    orderSku = String(orderSku || '').trim()
    var match = getWarrantyOptionsForSku(orderSku)

    if (!match) {
      showMsg('No warranty plan mapping was found for SKU: ' + orderSku)
      return false
    }

    var careButton = getPlanButton('GTEK Care')
    var carePlusButton = getPlanButton('GTEK Care+')
    var careVariant = findWarrantyVariant(match.iwbModel, match.opsPackage, 'GTEK Care')
    var carePlusVariant = findWarrantyVariant(match.iwbModel, match.opsPackage, 'GTEK Care+')

    if (!careVariant) {
      console.log('Warranty debug: no GTEK Care variant found for', match, variants)
    }

    if (!carePlusVariant) {
      console.log('Warranty debug: no GTEK Care+ variant found for', match, variants)
    }

    updatePlanButton(careButton, careVariant)
    updatePlanButton(carePlusButton, carePlusVariant)

    if (carePlusVariant && carePlusVariant.available) {
      setActivePlan(carePlusButton)
      return true
    }

    if (careVariant && careVariant.available) {
      setActivePlan(careButton)
      return true
    }

    showMsg('Warranty plans are unavailable for this product configuration.')
    return false
  }
  if (verifyForm) {
  verifyForm.addEventListener('submit', async function (event) {
    event.preventDefault()

    var serialNumber = serialInput.value.trim()
    var orderNumber = orderInput.value.trim()
    var submitBtn = verifyForm.querySelector('button[type="submit"]')

    if (!serialNumber) {
      showBox(failBox) 
      return
    }
    showMsg("Loading")
    hideEligibilityResult()
    if (submitBtn) submitBtn.disabled = true

    try {
      const res1 = await fetch(eligibilityUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          serialNumber: serialNumber,
          orderNumber: orderNumber
        })
      })

      if (!res1.ok) throw new Error('Warranty eligibility request failed.')

      const data1 = await res1.json()
      console.log('RETURN DATA', data1)

      var warrantyMatch = getWarrantyOptionsForSku(data1.orderSku)
      showEligibilityResult(warrantyMatch, data1.eligible === true)

      if (!data1.eligible) {
        showBox(failBox)
        return
      }
      const res2 = await fetch(
        `${registerationAppPath}?validateSerialNumber=true&serialNumber=${serialNumber}&render=1`    
      )
      if (!res2) throw new Error('Registration check request failed.')

      const data2 = await res2.json()
      console.log('Data2', data2)

      if (!data2.valid) {
        showBox(failBox)
        return
      }

      if (data2.html) {
        var parser = new DOMParser()
        var doc = parser.parseFromString(data2.html, 'text/html')

        if (typeof check_registration === 'function') {
          var registrationError = check_registration(doc)

          if (registrationError) {
            showMsg(registrationError)
            return
          }
        }
      }
      if (!applyWarrantyOptions(data1.orderSku)) {
        return
      }

      showBox(okBox)

    } catch (error) {
      console.log('Warranty debug error:', error)
      showBox(failBox)
    } finally {
      if (submitBtn) submitBtn.disabled = false
    }
  })

}

  if (!getActiveButton() && addText) {
    addText.textContent = lblUnavailable
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
  class ProductPage {
    constructor(section) {
      this.section = section;
      this.variants = this.readVariants();
      this.selectedOptions = this.getInitialOptions();
      this.bindGallery();
      this.bindZoom();
      this.bindOptions();
      this.bindQuantity();
      this.syncState();
    }

    readVariants() {
      const script = this.section.querySelector('[data-product-variants]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return [];
      }
    }

    getInitialOptions() {
      const selected = [];
      this.section.querySelectorAll('[data-option-button].is-selected').forEach((button) => {
        const index = Number(button.dataset.optionPosition) - 1;
        selected[index] = button.dataset.optionValue;
      });

      if (selected.length === 0 && this.variants[0]) {
        return [...this.variants[0].options];
      }

      return selected;
    }

    bindGallery() {
      this.section.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
        button.addEventListener('click', () => {
          this.showMedia(button.dataset.mediaId);
        });
      });
    }

    bindZoom() {
      this.zoom = this.section.querySelector('[data-product-zoom]');
      this.zoomImage = this.section.querySelector('[data-product-zoom-image]');
      this.zoomClose = this.section.querySelector('[data-product-zoom-close]');
      this.zoomPrevious = this.section.querySelector('[data-product-zoom-previous]');
      this.zoomNext = this.section.querySelector('[data-product-zoom-next]');
      this.zoomTriggers = Array.from(this.section.querySelectorAll('[data-product-zoom-trigger]'));
      this.zoomIndex = 0;
      this.previouslyFocusedElement = null;
      this.previousHtmlOverflow = '';
      this.previousBodyOverflow = '';

      this.zoomTriggers.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.openZoom(index);
        });
      });

      this.zoomClose?.addEventListener('click', () => {
        this.closeZoom();
      });

      this.zoom?.addEventListener('click', (event) => {
        if (event.target === this.zoom) {
          this.closeZoom();
        }
      });

      this.zoomPrevious?.addEventListener('click', (event) => {
        event.stopPropagation();
        this.showZoomImage(this.zoomIndex - 1);
      });

      this.zoomNext?.addEventListener('click', (event) => {
        event.stopPropagation();
        this.showZoomImage(this.zoomIndex + 1);
      });

      document.addEventListener('keydown', (event) => {
        if (!this.zoom || this.zoom.hidden) return;

        if (event.key === 'Escape') {
          this.closeZoom();
        } else if (event.key === 'ArrowLeft') {
          this.showZoomImage(this.zoomIndex - 1);
        } else if (event.key === 'ArrowRight') {
          this.showZoomImage(this.zoomIndex + 1);
        }
      });

      this.updateZoomControls();
    }

    bindOptions() {
      this.section.querySelectorAll('[data-option-button]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;

          const index = Number(button.dataset.optionPosition) - 1;
          this.selectedOptions[index] = button.dataset.optionValue;
          this.syncState();
        });
      });
    }

    bindQuantity() {
      const input = this.section.querySelector('[data-quantity-input]');
      const minus = this.section.querySelector('[data-quantity-minus]');
      const plus = this.section.querySelector('[data-quantity-plus]');

      if (!input) return;

      minus?.addEventListener('click', () => {
        const nextValue = Math.max(1, Number(input.value || 1) - 1);
        input.value = String(nextValue);
      });

      plus?.addEventListener('click', () => {
        const nextValue = Math.max(1, Number(input.value || 1) + 1);
        input.value = String(nextValue);
      });

      input.addEventListener('change', () => {
        input.value = String(Math.max(1, Number(input.value || 1)));
      });
    }

    openZoom(index) {
      if (!this.zoom || !this.zoomImage || this.zoomTriggers.length === 0) return;

      this.previouslyFocusedElement = document.activeElement;
      this.previousHtmlOverflow = document.documentElement.style.overflow;
      this.previousBodyOverflow = document.body.style.overflow;

      this.zoom.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      this.showZoomImage(index);
      this.zoomClose?.focus();
    }

    showZoomImage(index) {
      if (!this.zoomImage || this.zoomTriggers.length === 0) return;

      this.zoomIndex = (index + this.zoomTriggers.length) % this.zoomTriggers.length;

      const trigger = this.zoomTriggers[this.zoomIndex];
      const image = trigger?.querySelector('img');
      if (!image) return;

      this.zoomImage.src = image.currentSrc || image.src;
      this.zoomImage.srcset = image.srcset || '';
      this.zoomImage.sizes = '100vw';
      this.zoomImage.alt = image.alt || '';
      this.updateZoomControls();
    }

    updateZoomControls() {
      const hasMultipleImages = this.zoomTriggers && this.zoomTriggers.length > 1;

      if (this.zoomPrevious) this.zoomPrevious.hidden = !hasMultipleImages;
      if (this.zoomNext) this.zoomNext.hidden = !hasMultipleImages;
    }

    closeZoom() {
      if (!this.zoom || !this.zoomImage || this.zoom.hidden) return;

      this.zoom.hidden = true;
      this.zoomImage.removeAttribute('src');
      this.zoomImage.removeAttribute('srcset');
      this.zoomImage.removeAttribute('sizes');
      document.documentElement.style.overflow = this.previousHtmlOverflow;
      document.body.style.overflow = this.previousBodyOverflow;

      if (this.previouslyFocusedElement instanceof HTMLElement) {
        this.previouslyFocusedElement.focus();
      }
    }

    getSelectedVariant() {
      return this.variants.find((variant) => {
        return variant.options.every((value, index) => value === this.selectedOptions[index]);
      });
    }

    hasAvailableCombination(position, value) {
      const index = Number(position) - 1;

      return this.variants.some((variant) => {
        if (!variant.available) return false;

        return variant.options.every((optionValue, optionIndex) => {
          if (optionIndex === index) return optionValue === value;
          return this.selectedOptions[optionIndex] === optionValue;
        });
      });
    }

    syncState() {
      const variant = this.getSelectedVariant();

      this.section.querySelectorAll('[data-option-button]').forEach((button) => {
        const index = Number(button.dataset.optionPosition) - 1;
        const isSelected = this.selectedOptions[index] === button.dataset.optionValue;
        const isAvailable = this.hasAvailableCombination(
          button.dataset.optionPosition,
          button.dataset.optionValue
        );

        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        button.disabled = !isAvailable;
      });

      this.section.querySelectorAll('[data-selected-option-label]').forEach((label) => {
        const index = Number(label.dataset.selectedOptionLabel) - 1;
        const value = this.selectedOptions[index];
        if (value) label.textContent = `${value} selected`;
      });

      this.updateVariant(variant);
    }

    updateVariant(variant) {
      const variantInput = this.section.querySelector('[data-variant-id]');
      const price = this.section.querySelector('[data-product-price]');
      const addButton = this.section.querySelector('[data-add-to-cart]');
      const addText = this.section.querySelector('[data-add-to-cart-text]');
      const availability = this.section.querySelector('[data-product-availability] span');

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        if (availability) availability.textContent = 'Unavailable';
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = variant.price;

      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (availability) {
        availability.textContent = variant.available
          ? availability.dataset.defaultText || availability.textContent
          : 'Sold out';
        if (!availability.dataset.defaultText && variant.available) {
          availability.dataset.defaultText = availability.textContent;
        }
      }

      if (variant.featured_media_id) {
        this.showMedia(String(variant.featured_media_id));
      }
    }

    showMedia(mediaId) {
      if (!mediaId) return;

      this.section.querySelectorAll('[data-product-media]').forEach((media) => {
        const isActive = media.dataset.mediaId === mediaId;
        media.hidden = !isActive;
        media.classList.toggle('is-active', isActive);
      });

      this.section.querySelectorAll('[data-product-thumbnail]').forEach((thumb) => {
        const isActive = thumb.dataset.mediaId === mediaId;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    new ProductPage(section);
  });

  class SmartBoardSlider {
    constructor(slider) {
      this.slider = slider;
      this.track = slider.querySelector('[data-smart-board-slider-track]');
      this.slides = Array.from(slider.querySelectorAll('[data-smart-board-slide]'));
      this.dots = Array.from(slider.querySelectorAll('[data-smart-board-slider-dot]'));
      this.previous = slider.querySelector('[data-smart-board-slider-previous]');
      this.next = slider.querySelector('[data-smart-board-slider-next]');
      this.activeIndex = 0;

      if (!this.track || this.slides.length === 0) return;

      this.bindControls();
      this.bindScroll();
      this.syncDots();
    }

    bindControls() {
      this.previous?.addEventListener('click', () => {
        this.goTo(this.activeIndex - 1);
      });

      this.next?.addEventListener('click', () => {
        this.goTo(this.activeIndex + 1);
      });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goTo(index);
        });
      });
    }

    bindScroll() {
      let scrollTimer;

      this.track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const slideWidth = this.slides[0]?.clientWidth || 1;
          this.activeIndex = Math.round(this.track.scrollLeft / slideWidth);
          this.syncDots();
        }, 80);
      });
    }

    goTo(index) {
      const slideCount = this.slides.length;
      this.activeIndex = (index + slideCount) % slideCount;
      this.track.scrollTo({
        left: this.activeIndex * this.track.clientWidth,
        behavior: 'smooth',
      });
      this.syncDots();
    }

    syncDots() {
      this.dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === this.activeIndex ? 'true' : 'false');
      });
    }
  }

  document.querySelectorAll('[data-smart-board-slider]').forEach((slider) => {
    new SmartBoardSlider(slider);
  });
  })();

  } catch(e) { console.error(e); }
})();
})();
